module.exports = __webpack_public_path__ + "img/home_vip_banner_crown@2x.844081e5.png";